/* src/app/modules/shared/components/header-column/header-column-size/header-column-size.component.scss */
app-header-column-size {
  display: contents;
}
/*# sourceMappingURL=header-column-size.component.css.map */
